<!-- Teamübersicht -->
<header class="detail-header">
  <div class="detail-title">
    <h3>
      {{ team.name }}
      <span class="badge muted" *ngIf="!team.isActive">Inaktiv</span>
    </h3>
    <p>{{ team.description || 'Keine Beschreibung' }}</p>
  </div>
  <div class="detail-actions" *ngIf="canManage">
    <button mat-stroked-button (click)="edit.emit(team)" [disabled]="store.busy">
      <mat-icon>edit</mat-icon> Bearbeiten
    </button>
    <button mat-icon-button class="danger" (click)="deleteTeam()" [disabled]="store.busy"
      matTooltip="Team löschen" aria-label="Team löschen">
      <mat-icon>delete_outline</mat-icon>
    </button>
  </div>
</header>

<div class="facts">
  <div class="fact">
    <mat-icon>verified_user</mat-icon>
    <div><small>Teamleitung</small><strong>{{ team.leaderName || 'nicht festgelegt' }}</strong></div>
  </div>
  <div class="fact">
    <mat-icon>group</mat-icon>
    <div><small>Mitglieder</small><strong>{{ team.memberCount }}</strong></div>
  </div>
  <button mat-stroked-button color="primary" class="fact-action" *ngIf="canMakeMyPrimary"
    [disabled]="store.busy" (click)="makeMyPrimary()">
    <mat-icon>star_outline</mat-icon> Als mein Hauptteam festlegen
  </button>
</div>

<p class="hint warn" *ngIf="!team.leaderUserId">
  <mat-icon>warning_amber</mat-icon>
  Dieses Team hat noch keine Teamleitung. Ohne Teamleitung kann niemand die Urlaubsanträge der Mitglieder genehmigen.
</p>

<!-- Verwaltung: Mitglieder hinzufügen, Teamleitung -->
<section class="manage-grid" *ngIf="canManage">
  <div class="manage-block">
    <h4 class="section-title">Mitglieder hinzufügen</h4>
    <div class="inline">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Mitarbeiter auswählen</mat-label>
        <mat-select [(ngModel)]="newMemberIds" multiple [disabled]="store.busy">
          <div class="select-search">
            <input class="select-search-input" placeholder="Name oder E-Mail suchen …" [(ngModel)]="memberSearch"
              (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          </div>
          <mat-option *ngFor="let user of availableUsers" [value]="user.userId">
            {{ user.name }}<span class="option-mail" *ngIf="user.email"> · {{ user.email }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-flat-button color="primary" [disabled]="store.busy || !newMemberIds.length" (click)="addMembers()">
        <mat-icon>person_add</mat-icon> Hinzufügen
      </button>
    </div>
  </div>

  <div class="manage-block">
    <h4 class="section-title">Teamleitung {{ team.leaderUserId ? 'ändern' : 'festlegen' }}</h4>
    <div class="inline">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Teamleitung</mat-label>
        <mat-select [(ngModel)]="leaderId" [disabled]="store.busy || !team.members.length">
          <mat-option *ngFor="let member of team.members" [value]="member.userId">{{ member.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button [disabled]="store.busy || !leaderId || leaderId === team.leaderUserId"
        (click)="changeLeader()">
        Übernehmen
      </button>
    </div>
  </div>
</section>

<!-- Teammitglieder -->
<section class="members">
  <div class="members-head">
    <h4 class="section-title">Teammitglieder <span class="count">{{ team.members.length }}</span></h4>
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="member-filter" *ngIf="team.members.length > 6">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="memberFilter" placeholder="Mitglieder suchen" aria-label="Mitglieder filtern">
    </mat-form-field>
  </div>

  <div class="empty" *ngIf="!team.members.length">
    <mat-icon>group_add</mat-icon>
    Noch keine Mitglieder.
  </div>

  <div class="member-list" *ngIf="team.members.length">
    <div class="member" *ngFor="let member of members; trackBy: trackMember"
      [class.clickable]="canOpenProfile(member.userId)"
      (click)="canOpenProfile(member.userId) && openProfile.emit(member.userId)">
      <div class="avatar">{{ member.name.charAt(0).toUpperCase() }}</div>

      <div class="member-main">
        <div class="member-name">
          <strong>{{ member.name }}</strong>
          <span class="badge leader" *ngIf="member.isLeader"><mat-icon>verified_user</mat-icon>Teamleitung</span>
          <span class="badge primary" *ngIf="isPrimary(member)" matTooltip="Dieses Team ist das Hauptteam (Urlaubsfreigabe)">
            <mat-icon>star</mat-icon>Hauptteam
          </span>
        </div>
        <small>{{ member.email || member.userId }}</small>
        <div class="skills" *ngIf="memberSkills(member.userId).length">
          <span class="skill-chip" *ngFor="let skill of memberSkills(member.userId)">
            <span class="skill-dot" [style.backgroundColor]="skill.color || '#607d8b'"></span>{{ skill.name }}
          </span>
        </div>
      </div>

      <div class="member-actions" (click)="$event.stopPropagation()">
        <button mat-icon-button *ngIf="canOpenProfile(member.userId)" matTooltip="Profil öffnen"
          (click)="openProfile.emit(member.userId)" [attr.aria-label]="'Profil von ' + member.name">
          <mat-icon>badge</mat-icon>
        </button>
        <button mat-icon-button *ngIf="canManage && !member.isLeader" [disabled]="store.busy"
          matTooltip="Aus dem Team entfernen" (click)="removeMember(member)" [attr.aria-label]="member.name + ' entfernen'">
          <mat-icon>person_remove</mat-icon>
        </button>
      </div>
    </div>
    <p class="empty" *ngIf="!members.length">Keine Mitglieder passend zur Suche.</p>
  </div>
</section>
